import { render, staticRenderFns } from "./ComplianceCertification.vue?vue&type=template&id=5c787fc8&scoped=true"
import script from "./ComplianceCertification.vue?vue&type=script&lang=js"
export * from "./ComplianceCertification.vue?vue&type=script&lang=js"
import style0 from "./ComplianceCertification.vue?vue&type=style&index=0&id=5c787fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c787fc8",
  null
  
)

export default component.exports